module.exports = __webpack_public_path__ + "img/bunny.74cb69e3.gif";